import { FC } from 'react';
import { camelToNormalize } from '@repo-level/core-front';

import { ScErrorGroup } from './styled';

import error from 'theme/images/errorIcon.svg';

export const ErrorGroup: FC = ({ children }) => {
  return (
    <ScErrorGroup>
      <img src={error} alt="error" />
      {children}
    </ScErrorGroup>
  );
};

export type ErrorServe = {
  field: string;
  message: string | string[];
};

export const ErrorGroupList: FC<{ errors: ErrorServe[] }> = ({ errors }) => {
  return errors.length ? (
    <ErrorGroup>
      <ul>
        {errors.map(({ field, message }, index) => (
          <li key={index}>
            <span>{camelToNormalize(field)}</span>:{' '}
            {typeof message === 'string' ? message : message.join(', ')}
          </li>
        ))}
      </ul>
    </ErrorGroup>
  ) : null;
};
